import { createSvgIcon } from '@mui/material';

const IconArrowUpward = createSvgIcon(
  <path d="M11 20V7.825L5.4 13.425L4 12L12 4L20 12L18.6 13.425L13 7.825V20H11Z" />,
  'arrow_upward'
);

export default IconArrowUpward;
